import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import productService from 'v2/services/product';

type Payload = {
  productId: number;
  customerEmail: string;
};

export function useProductDeliveryMutation(options: UseMutationOptions<any, unknown, Payload> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ productId, customerEmail }: Payload) => productService.manualDelivery(productId, customerEmail),
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['product'] });
      options.onSuccess?.(...args);
    }
  });
}
